import { render } from "./DataKildeInfo.vue?vue&type=template&id=4a947f56&scoped=true"
import script from "./DataKildeInfo.vue?vue&type=script&lang=js"
export * from "./DataKildeInfo.vue?vue&type=script&lang=js"

import "./DataKildeInfo.vue?vue&type=style&index=0&id=4a947f56&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a947f56"]])

export default __exports__